import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchReset from '../../Reset';
import { DEFAULT_TEXT } from '../../../config/constants';
const SearchResultsEmptyState = props => {
  const {
    t
  } = useTranslation();
  const {
    emptyState,
    emptyStateTitle = t(['searchkit.empty_state.title', DEFAULT_TEXT.EMPTY_STATE.TITLE]),
    emptyStateBody = t(['searchkit.empty_state.body', DEFAULT_TEXT.EMPTY_STATE.BODY])
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "Searchkit__Results__EmptyState"
  }, emptyState || /*#__PURE__*/React.createElement("div", {
    className: "Searchkit__Results__EmptyState__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Searchkit__Results__EmptyState__title"
  }, /*#__PURE__*/React.createElement("h2", null, emptyStateTitle)), /*#__PURE__*/React.createElement("div", {
    className: "Searchkit__Results__EmptyState__body"
  }, /*#__PURE__*/React.createElement("p", null, emptyStateBody)), /*#__PURE__*/React.createElement(SearchReset, null)));
};
export default SearchResultsEmptyState;